export default "__VITE_ASSET__Ctu9Yaex__"